<template>
<div>
 
  <!-- type="border-card" -->
 
  <el-tabs v-model="activeName" @tab-click="handleClicks">
    <el-tab-pane :name="`${index}`" v-for="(item,index) in  activeList" :key="index">
      <span slot="label">{{item}}</span>
    </el-tab-pane>
  </el-tabs>
  <el-table :data="classTable" style="width: 100%" :span-method="objectSpanMethod" border  v-loading="listLoading">
    <el-table-column align="center" prop="standard_name" show-overflow-tooltip label="商品标准名称"> </el-table-column>
    <el-table-column align="center" prop="talent_name" show-overflow-tooltip label="资质名称">
        <template slot-scope="scope">
             <span  v-if="scope.row.talent_name">{{scope.row.talent_name }}</span>
         <span  v-else>-</span>
      </template>
       </el-table-column>
    <el-table-column align="center" prop="talent_image_url" show-overflow-tooltip label="资质文件">
      <template slot-scope="scope">
        <img :src="scope.row.talent_image_url" style="width:40px" v-if="scope.row.talent_image_url">
         <span  v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column align="center" label="详细说明">
      <template slot-scope="scope">
        <span style="color:blue" v-if="scope.row.explain">{{scope.row.explain }}</span>
        <span  v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column align="center" prop="create_time" label="提交时间" v-if="activeName == 0"> </el-table-column>
    <el-table-column align="center" prop="check_time" label="审核时间" v-else> </el-table-column>

    <el-table-column align="center" prop="address" label="操作"  v-if="activeName == 2">
        <template slot-scope="{ row }">
          <div class="link">
            <!-- @click="goView(row.message)" -->
            <el-link type="primary" style="margin-right:10px" @click="goView(row)"
                     >查看原因</el-link>
            <el-link type="primary"
                     @click="editShow(row)">编辑</el-link>
    <!--         <span v-else>-</span> -->
          </div> 
        </template>
    </el-table-column>
  </el-table>
  <!-- 分页 -->
  <PaginaTion v-if="classTable.length>0" :total="total" :pageNum="pageNum" :pageSize="pageSize" @pageChange="pageChange" />
  </div>
</template>

<script>
import PaginaTion from '@/components/pagination/index.vue'
import {
  mapGetters,
  mapActions
} from "vuex";
export default {
  props: ['shopId'],
  data() {
    return {
      activeName: '0',
      activeList: ['待审核', '审核通过', '审核拒绝', ],
      classTable: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      provinceArr: [],
      provincePos: 0,
      viewDetail:'',
      listLoading:false

    };
  },
    computed: {
    ...mapGetters(["getToken", "getUserInfo"]),
  },
  methods: {
    ...mapActions({
      strandList: "newshop/strandList"
    }),
    pageChange(page) {
      this.pageSize = page._pageSize;
      this.pageNum = page._currentPage;
       this.classTable = []
      this.getstrandList(this.shopId)
    },
    editShow(item){
this.$emit('editShow',item)
    },
    goView(row) {
      console.log(row,'mess--')
        this.$confirm(`${row.message==null?"暂无原因":row.message}`, '查看原因', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
  
        }).catch(() => { });
    },
    handleClicks() {
      this.classTable = []
      this.merageInit()
      this.getstrandList(this.shopId)
    },
    //初始化
    merageInit() {
      this.provinceArr = []
      this.provincePos = 0
    },
    objectSpanMethod({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (columnIndex === 0) { //第一列的合并方法
        const _row_1 = this.provinceArr[rowIndex];
        const _col_1 = _row_1 > 0 ? 1 : 0; //如果被合并了_row=0则它这个列需要取消
        return {
          rowspan: _row_1,
          colspan: _col_1
        }
      }
    },
    getstrandList(shop_id) {
      this.listLoading==true
      let params = {
        token:this.getToken,
        shop_id: shop_id,
        is_check: this.activeName == '0' ? 3 : this.activeName,
        page: this.pageNum,
        limit: this.pageSize
      }
      this.strandList(params).then((res) => {
        if (res.code == 1) {
          this.listLoading==false
          /* let arr = [{
              "id": 71354,
              "status": 0,
              "shop_id": 81610,
              "standard_id": 1,
              "is_deleted": 0,
              "create_time": "2022-05-20 17:23:29",
              "update_time": "2022-05-20 17:23:29",
              "is_check": 0,
              "check_time": null,
              "message": null,
              "standard_name": "电子书", //商品标准名称
              "talent_list": [{
                  "shop_id": 81610,
                  "talent_id": 68504,
                  "talent_name": "阿松大大", // 资质名称
                  "image_url": "https://img2.baidu.com/it/u=4244269751,4000533845&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500", //资质图片url
                  "is_must": 1, //资质图片url
                  "explain": "资质说明"
                },
                {
                  "shop_id": 81610,
                  "talent_id": 68504,
                  "talent_name": "阿松大大", // 资质名称
                  "image_url": "https://img2.baidu.com/it/u=4244269751,4000533845&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500", //资质图片url
                  "is_must": 1, //资质图片url
                  "explain": "资质说明"
                },
                {
                  "shop_id": 81610,
                  "talent_id": 68503,
                  "talent_name": "阿松大",
                  "image_url": "https://img1.baidu.com/it/u=592570905,1313515675&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
                  "is_must": 0,
                  " explain": "cdhnkjfjg gifslg"
                }
              ]
            },
            {
              "id": 71355,
              "status": 0,
              "shop_id": 81610,
              "standard_id": 1,
              "is_deleted": 0,
              "create_time": "2022-05-20 17:23:29",
              "update_time": "2022-05-20 17:23:29",
              "is_check": 0,
              "check_time": null,
              "message": null,
              "standard_name": "电子书2", //商品标准名称
              "talent_list": [{
                  "shop_id": 81610,
                  "talent_id": 68504,
                  "talent_name": "阿松大大", // 资质名称
                  "image_url": "https://img2.baidu.com/it/u=4244269751,4000533845&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500", //资质图片url
                  "is_must": 1, //资质图片url
                  "explain": "资质说明"
                },
                {
                  "shop_id": 81610,
                  "talent_id": 68504,
                  "talent_name": "阿松大大", // 资质名称
                  "image_url": "https://img2.baidu.com/it/u=4244269751,4000533845&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500", //资质图片url
                  "is_must": 1, //资质图片url
                  "explain": "资质说明"
                },
                {
                  "shop_id": 81610,
                  "talent_id": 68503,
                  "talent_name": "阿松大",
                  "image_url": "https://img1.baidu.com/it/u=592570905,1313515675&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
                  "is_must": 0,
                  " explain": "cdhnkjfjg gifslg"
                }
              ]
            },
          })total: 0, lists: []
          ] */
         /*  console.log(arr, 'arr--') */
          res.data.lists.forEach(el => {
            if ( el.talent_list.length>0) {
               el.talent_list.forEach(elt => {
              let obj = {
                standard_name: el.standard_name,
                standard_id: el.standard_id,
                id: el.id,
                create_time: el.create_time,
                check_time: el.check_time,
                status: el.status,
                talent_id: elt.talent_id,
                talent_name: elt.talent_name,
                talent_image_url: elt.image_url,
                explain: elt.explain,
                is_must:elt.is_must,
                message:el.message
              }
              this.classTable.push(obj)
            })
            }else{
              let obj = {
                standard_name: el.standard_name,
                standard_id: el.standard_id,
                id: el.id,
                create_time: el.create_time,
                status: el.status,
                  message:el.message
              }
              console.log(obj,'obj',el.message)
               this.classTable.push(obj)
            } 
          })
          this.total =parseInt(res.data.total)
          for (var i = 0; i < this.classTable.length; i++) {
            if (i === 0) {
              //第一行必须存在
              this.provinceArr.push(1)
              this.provincePos = 0
            } else {
              // 判断当前元素与上一个元素是否相同 this.provincePos是provinceArr内容的序号
              if (this.classTable[i].standard_name === this.classTable[i - 1].standard_name) {
                this.provinceArr[this.provincePos] += 1
                this.provinceArr.push(0)
              } else {
                this.provinceArr.push(1)
                this.provincePos = i
              }
            }
          }
        }
      }).catch((err) => {

      });
    },
  },
  components: {
    PaginaTion,
  },
};
</script>

<style scoped lang="csss">
</style>
